import { useMemo } from "react";
import { useCourseIndexRoute } from "@tecnobit-srl/route-types-course-index/lazy";
import { useMyCourseIndexRoute } from "@tecnobit-srl/route-types-my-course-index/lazy";
import { useMyCourseRoute } from "@tecnobit-srl/route-types-my-course/lazy";
import { useMyCourseLessonRoute } from "@tecnobit-srl/route-types-my-course-lesson/lazy";
import { useMyCourseLessonQuizRoute } from "@tecnobit-srl/route-types-my-course-lesson-quiz/lazy";
import { useMyCourseLessonVideoRoute } from "@tecnobit-srl/route-types-my-course-lesson-video/lazy";
import { useMyCourseLessonMaterialsRoute } from "@tecnobit-srl/route-types-my-course-lesson-materials/lazy";
//#region src/index.ts
var useCoursesRouteTypes = () => {
	const courseIndexRoute = useCourseIndexRoute();
	const myCourseIndexRoute = useMyCourseIndexRoute();
	const myCourseRoute = useMyCourseRoute();
	const myCourseLessonRoute = useMyCourseLessonRoute();
	const myCourseLessonQuizRoute = useMyCourseLessonQuizRoute();
	const myCourseLessonVideoRoute = useMyCourseLessonVideoRoute();
	const myCourseLessonMaterialsRoute = useMyCourseLessonMaterialsRoute();
	return useMemo(() => ({
		...courseIndexRoute,
		...myCourseIndexRoute,
		...myCourseRoute,
		...myCourseLessonRoute,
		...myCourseLessonQuizRoute,
		...myCourseLessonVideoRoute,
		...myCourseLessonMaterialsRoute
	}), [
		courseIndexRoute,
		myCourseIndexRoute,
		myCourseRoute,
		myCourseLessonRoute,
		myCourseLessonQuizRoute,
		myCourseLessonVideoRoute,
		myCourseLessonMaterialsRoute
	]);
};
//#endregion
export { useCoursesRouteTypes };
